import React from 'react';
import { SEOHeadBewertungen } from '../components/SEOHeadBewertungen';
import { Header } from '../components/Header';
import { HeroBewertungen } from '../components/bewertungen/HeroBewertungen';
import { KurzErklaertBewertungen } from '../components/bewertungen/KurzErklaertBewertungen';
import { PlattformenUebersicht } from '../components/bewertungen/PlattformenUebersicht';
import GoogleReviews from '../components/GoogleReviews';
import { WarumBewertungenWichtig } from '../components/bewertungen/WarumBewertungenWichtig';
import { BrueckeBewertungen } from '../components/bewertungen/BrueckeBewertungen';
import { FAQBewertungen } from '../components/bewertungen/FAQBewertungen';
import { AbschlussBewertungen } from '../components/bewertungen/AbschlussBewertungen';
import { Footer } from '../components/Footer';
import { MobileStickyCTA } from '../components/MobileStickyCTA';

const BewertungenPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHeadBewertungen />
      <Header />
      <main>
        <HeroBewertungen />
        <KurzErklaertBewertungen />
        <PlattformenUebersicht />
        
        {/* Echte Google Bewertungen */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Echte Google Bewertungen
              </h2>
              <p className="text-lg text-gray-600">
                Was unsere Kunden über uns sagen
              </p>
            </div>
            <GoogleReviews />
          </div>
        </section>
        
        <WarumBewertungenWichtig />
        <BrueckeBewertungen />
        <FAQBewertungen />
        <AbschlussBewertungen />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
};

export default BewertungenPage;